<template>
  <div
    :class="containerCSSClass"
    :to="route"
    @click="handleClick"
  >
    <div
      class="owal faces list cell content"
    >
      <img
        v-if="face.images && face.images.length"
        v-lazy="imageUrl"
        class="owal faces list cell avatar"
      >
      <img
        v-else
        v-lazy="placeholderImageURI"
        :error="placeholderImageURI"
        class="owal faces list cell avatar"
      >
      <span
        class="owal faces list cell main"
      >
        <span
          class="owal faces list cell title"
        >
          {{ face.person_name }}
        </span>
      </span>
      <div
        class="owal faces list cell meta"
      >
        <!-- <span
        class=" owal faces list cell subtitle"
      >
        {{ location }}
      </span> -->
        <span
          class=" owal faces list cell subtitle"
        >
          {{ timeAgo }}
        </span>
      </div>
      <i
        class="owal faces list cell chevron el-icon-arrow-right"
      />
    </div>
    <span
      class="owal faces list cell border"
    />
  </div>
</template>

<script>
import moment from 'moment'
import { titleCase } from '@/libraries/util/string'

export default {
  name: 'FacesListCell',
  props: {
    face: {
      type: Object,
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
    click: {
      type: Function,
    },
  },
  computed: {
    imageUrl () {
      return `${this.face.images[0].thumbnail_uri}?cacheBust=${new Date().valueOf()}`
    },
    route () {
      return `/faces/${this.face.frontend_face_uuid}`
    },
    location () {
      const face = this.face

      if (!face) {
        return ''
      }
      if (!face.last_seen_camera_description) {
        return ''
      }

      return titleCase(face.last_seen_camera_description)
    },
    timeAgo () {
      const face = this.face

      if (!face) {
        return ''
      }

      if (!face.last_seen_datetime) {
        return ''
      }
      const timestamp = face.last_seen_datetime
      let timeAgo = moment(timestamp).fromNow()
      const isFutureTime = timeAgo.startsWith('in') // "in N minutes, etc"
      if (isFutureTime) {
        timeAgo = 'just now'
      }

      return timeAgo
    },
    containerCSSClass () {
      const imageAcceptable = this.face.image_acceptable
      const cssClass = `owal faces list${this.active ? ' active ' : ' '}cell container ${imageAcceptable ? 'blue' : 'orange'}`
      return cssClass
    },
  },
  methods: {
    handleClick () {
      if (this.click) {
        this.click(this.face.frontend_face_uuid)
      } else {
        this.$emit('click', this.face.frontend_face_uuid)
      }
    },
  },
}
</script>

<style scoped>

.owal.faces.list.cell.container {
  display: flex;
  flex-direction: column;
  background-color: rgba(255, 255, 255, 1.0);
  font-family: "HelveticaNeue", "Helvetica", sans-serif;
  cursor: pointer;
  transition: all 0.3s ease;
}

.owal.faces.list.cell.container:hover
{
  background-color: rgba(236, 245, 255, 0.988235);
  border-left: 3px solid;
  border-left-color: #47566966;
}

.owal.faces.list.cell.container.orange:hover {
  background-color: rgba(246, 170, 136, 1);
  color: rgb(243, 244, 245);
  border-left-color: #ffa500;
}

.owal.faces.list.active.cell.container.blue
{
  background-color: rgba(206, 226, 250, 0.988);
}

.owal.faces.list.cell.container.orange,
.owal.faces.list.active.cell.container.orange {
  background-color: rgba(246, 170, 136, 0.85);
  color: rgb(243, 244, 245);

}

.owal.faces.list.cell.content {
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  padding: 0.33rem 0 0.33 1.06rem;
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}

.owal.faces.list.cell.border {
  background: #475669;
  height: 1px;
  opacity: 0.5;
  width: 300px;
  align-self: flex-end;
  right: 0;
  bottom: 0;
  top: auto;
}

.owal.faces.list.avatar {
  background-color: #EFF2F7;
  object-fit: cover;
  height: 48px;
  width: 48px;
  border-radius: 24px;
  margin: 0.33rem 1.06rem 0.33rem 1rem;
  /* transition: box-shadow 0.3s cubic-bezier(0.445, 0.05, 0.55, 0.95); */
}

.owal.faces.list.cell.container:hover .owal.faces.list.avatar {
  /* box-shadow: #47566966 0 8px 18px 0; */
}

.owal.faces.list.active.cell.container .owal.faces.list.avatar {
  /* box-shadow: #475669 0 10px 20px 0; */
}

.owal.faces.list.cell.title {
  font-size: 1rem;
  flex-shrink: 0;
  flex-grow: 2;
}

.owal.faces.list.cell.meta {
  display: flex;
  flex-direction: column;
  margin-right: .33rem;
  padding: 0;
  flex-grow: 1;
  flex-shrink: 2;
}

.owal.faces.list.cell.subtitle {
  display: flex;
  flex-direction: row-reverse;
  width: 100%;
  font-size: 13px;
  text-align: right;
  align-self: flex-end;
}

.owal.faces.list.cell.chevron {
  width: 24px;
}

/** Blue Cell, Title */
.owal.faces.list.cell.container.blue .owal.faces.list.cell.title,
.owal.faces.list.active.cell.container.blue .owal.faces.list.cell.title {
  color: rgb(71, 86, 105);
}

/** Orange Cell, Title */
.owal.faces.list.active.cell.container.orange .owal.faces.list.cell.title {
  color: rgb(255, 255, 255);
}

/** Blue Cell, Subtitle */
.owal.faces.list.cell.container.blue .owal.faces.list.cell.subtitle,
.owal.faces.list.active.cell.container.blue .owal.faces.list.cell.subtitle {
  color:#8492A6;
}

/** Orange Cell, Subtitle */
.owal.faces.list.cell.container.orange .owal.faces.list.cell.subtitle,
.owal.faces.list.active.cell.container.orange .owal.faces.list.cell.subtitle {
  color: #F3F4F5;
}

/* Active cell */
.owal.faces.list.cell.container,
.owal.faces.list.cell.container:hover,
.owal.faces.list.active.cell.container,
.owal.faces.list.active.cell.container:hover, {
  transition: all 0.2s linear;
}
.owal.faces.list.active.cell.container .owal.faces.list.cell.title,
.owal.faces.list.active.cell.container .owal.faces.list.cell.chevron {
  color: #409EFF;
}

.owal.faces.list.active.cell.container {
  border-left: 3px solid;
  padding-left: -3px;
}

.owal.faces.list.active.cell.container.orange {
  border-left-color: #ffa500;
}

</style>
